<section class="flex-container login">
  <div class="col-50 cover cover-admin"></div>
  <div class="col-50 center content">
    <div class="center login-form">
      <a routerLink="/">
        <img src="assets/img/logo.webp" alt="Deluxy" class="logo">
      </a>
      <br>
      <span class="riga"></span>
      <h3>Registrati</h3>
      <form [formGroup]="registrationForm" (ngSubmit)="submit()">
        <div class="input">
          <input type="text" name="name" formControlName="name" placeholder="Nome">
          <app-error-html-handler [ctrl]="registrationForm.get('name')" [messages]="formValidationMsgs.name">
          </app-error-html-handler>
        </div>

        <div class="input">
          <input type="text" name="surname" formControlName="surname" placeholder="Cognome">
          <app-error-html-handler [ctrl]="registrationForm.get('surname')" [messages]="formValidationMsgs.surname">
          </app-error-html-handler>
        </div>

        <div class="input">
          <input type="email" name="email" formControlName="email" placeholder="Email">
          <app-error-html-handler [ctrl]="registrationForm.get('email')" [messages]="formValidationMsgs.email">
          </app-error-html-handler>
        </div>

        <div class="input">
          <input type="password" name="password1" formControlName="password1" placeholder="Password">
          <app-error-html-handler [ctrl]="registrationForm.get('password1')" [messages]="formValidationMsgs.password1">
          </app-error-html-handler>
        </div>

        <div class="input">
          <input type="password" name="password2" formControlName="password2" placeholder="Conferma password">
          <app-error-html-handler [ctrl]="registrationForm.get('password2')" [messages]="formValidationMsgs.password2">
          </app-error-html-handler>
        </div>

        <div class="center">
          <button class="btn hvr-shrink" type="submit" [disabled]="!registrationForm?.valid">
            Registrati<i class="ml-10 fas fa-arrow-right"></i></button>
        </div>
      </form>
    </div>
  </div>
</section>
